"use client";
import * as React from "react";
const SvgEditRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 12.85v2.7a.44.44 0 0 0 .44.45h2.7a.4.4 0 0 0 .32-.13l9.7-9.7-3.33-3.33-9.7 9.7a.4.4 0 0 0-.13.31M15.74 3.6a.9.9 0 0 0 0-1.25L13.66.26a.9.9 0 0 0-1.25 0l-1.63 1.63 3.33 3.33z" }));
export {
  SvgEditRound as default
};
